<template>
  <div class="dialog-bg" @click.self="onConfirm(false)">
    <div class="dialog-box">
      <div class="title">
        {{ data.title || "Alert" }}
      </div>
      <div class="subTitle text" v-if="data.subTitle">
        {{ data.subTitle }}
      </div>
      <div class="mark" v-if="data.remark">
        <p class="remark" v-if="data.remark && data.secondRemark">
          * {{ data.remark }}<br>
          ** {{ data.secondRemark }}
        </p>
        <p v-else class="remark">
          * {{ data.remark }}
        </p>
      </div>
      <div class="detail" v-if="hasDefaultSlot">
        <slot></slot>
      </div>
      <div v-else-if="data.detail">
        <div class="detail text" v-if="!isHTML">
          {{ data.detail }}
        </div>
        <div class="detail html" v-else>
          <div v-html="data.detail"></div>
        </div>
      </div>
      <div class="button" v-if="!data.hideAction">
        <div class="row">
          <div class="col p-0" v-if="data.buttonCancel">
            <button
              type="button"
              class="btn-block pointer"
              @click.once="onConfirm(false)"
              :disabled="data.disableCancel"
            >
              {{ data.buttonCancel }}
            </button>
          </div>
          <div class="col p-0" v-if="data.buttonSubmit">
            <button
              type="button"
              class="btn-block pointer text-danger"
              id="confirm-btn"
              @click.prevent="onConfirm(true)"
              :disabled="data.disableSubmit"
            >
              {{ data.buttonSubmit }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "isHTML"],
  created() {},
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    }
  },
  methods: {
    onConfirm(action) {
      this.$emit("confirm", action);
    }
  }
};
</script>

<style scoped>
.dialog-box {
  padding: 0;
  border-radius: 15px;
  position: absolute;
  background-color: #fcfcfc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 290px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000;

  padding: 24px 40px;
}
.detail {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;

  padding: 0px 60px;
  padding-bottom: 15px;
}
.subTitle {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;

  padding: 0px 60px;
  padding-bottom: 15px;
}
button {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: center;
  color: #212121;

  border: none;
  background-color: transparent;
  padding: 16px 0;
}
.button {
  margin-top: 16px;
  padding: 0 15px;
  border-top: 1px solid #e0e0e0;
}
.button > .row > div:nth-child(2) {
  border-left: 1px solid #e0e0e0;
}
.close {
  position: absolute;
  top: 10px;
  right: 15px;
  color: rgba(255, 255, 255, 1);
  z-index: 100;
}
.remark {
	font-size: 14px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
.mark {
  padding: 0px 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/helper/dialog/Confirm.vue